/* Brilinton Center Page Controller
   Handles Area > Category > Section > Topic navigation, clean URL hashes,
   sidebar/drawer menus, with final center-* markup only.
   V24: same-page menu child hashes bind as in-page Center scroll links. */
(function () {
  if (window.BrilintonCenterPageController) return;

  function normalizeHash(hash) {
    if (!hash || hash === '#') return hash;
    return hash;
  }

  function getTitle(section) {
    return section.querySelector('.center-section__title')?.textContent.trim() ||
      section.querySelector('h2,h3')?.textContent.trim() ||
      section.id || '';
  }

  function CenterPage(root) {
    this.root = root;
    this.drawer = document.getElementById('centerMobileDrawer');
    this.subTabHeading = document.getElementById('centerNavCurrentLabel');
    this.pageTitle = root.querySelector('.center-article__title')?.textContent.trim() || document.querySelector('.center-nav__context-current')?.dataset.defaultSubheading || '';
    this.contentArea = root.querySelector('[data-center-content]') || root;
    this.upgradeSemanticPolicyContent();
    this.panels = Array.from(this.contentArea.querySelectorAll('.center-section'));
    this.scrollLinks = [];
    this.init();
  }


  function slugify(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  CenterPage.prototype.upgradeSemanticPolicyContent = function () {
    if (!this.root.classList.contains('center-page--policies-legal')) return;
    if (this.contentArea.querySelector('.center-section')) return;

    var children = Array.from(this.contentArea.children).filter(function (node) {
      return !(node.tagName === 'P' && !node.textContent.trim());
    });
    if (!children.length) return;

    var fragment = document.createDocumentFragment();
    var currentSection = null;
    var currentBody = null;
    var currentTopic = null;
    var usedIds = {};

    function uniqueId(base) {
      var clean = slugify(base);
      var id = clean;
      var i = 2;
      while (usedIds[id] || document.getElementById(id)) {
        id = clean + '-' + i;
        i += 1;
      }
      usedIds[id] = true;
      return id;
    }

    function createSection(title, isFirst) {
      var section = document.createElement('section');
      section.className = 'center-section' + (isFirst ? ' is-open' : '');
      section.setAttribute('data-center-section', '');
      section.id = uniqueId(title);

      var button = document.createElement('button');
      button.className = 'center-section__summary';
      button.type = 'button';
      button.setAttribute('aria-expanded', isFirst ? 'true' : 'false');

      var titleSpan = document.createElement('span');
      titleSpan.className = 'center-section__title';
      titleSpan.textContent = title;

      var caret = document.createElement('span');
      caret.className = 'center-section__caret';
      caret.setAttribute('aria-hidden', 'true');

      button.appendChild(titleSpan);
      button.appendChild(caret);

      var body = document.createElement('div');
      body.className = 'center-section__body';

      section.appendChild(button);
      section.appendChild(body);
      fragment.appendChild(section);
      return { section: section, body: body };
    }

    function createTopic(title, sectionBody, sectionId) {
      var topic = document.createElement('article');
      topic.className = 'center-topic';
      topic.setAttribute('data-center-topic', '');
      topic.id = uniqueId(sectionId + '--' + title);

      var heading = document.createElement('h3');
      heading.textContent = title;
      topic.appendChild(heading);
      sectionBody.appendChild(topic);
      return topic;
    }

    children.forEach(function (node) {
      if (node.matches && node.matches('h2')) {
        var sectionData = createSection(node.textContent.trim(), !currentSection);
        currentSection = sectionData.section;
        currentBody = sectionData.body;
        currentTopic = null;
        node.remove();
        return;
      }

      if (node.matches && node.matches('h3')) {
        if (!currentSection) {
          var defaultData = createSection('Policy Details', true);
          currentSection = defaultData.section;
          currentBody = defaultData.body;
        }
        currentTopic = createTopic(node.textContent.trim(), currentBody, currentSection.id);
        node.remove();
        return;
      }

      if (!currentSection) {
        var introData = createSection('Policy Overview', true);
        currentSection = introData.section;
        currentBody = introData.body;
      }

      if (!currentTopic) {
        currentTopic = createTopic('Overview', currentBody, currentSection.id);
      }

      currentTopic.appendChild(node);
    });

    this.contentArea.innerHTML = '';
    this.contentArea.appendChild(fragment);
  };



  function getStaticSubmenuMap(root) {
    if (!root) return {};

    if (root.classList.contains('center-page--client-care')) {
      return {
        '/pages/orders-delivery': [
          ['Payments & Checkout', '#payments-checkout'],
          ['Order Changes', '#order-changes'],
          ['Import Duties & Taxes', '#import-duties'],
          ['Delivery Issues', '#delivery-issues'],
          ['Shipping & Tracking', '#shipping-tracking'],
          ['Brilinton Pre-Orders', '#pre-orders']
        ],
        '/pages/returns-refunds': [
          ['Return Policy & Process', '#return-policy-process'],
          ['Refunds & Exchanges', '#refunds-exchanges'],
          ['Return Exceptions', '#return-exceptions']
        ],
        '/pages/general-information': [
          ['House Of Brilinton', '#house-of-brilinton'],
          ['Product Authenticity', '#product-authenticity'],
          ['Contact Brilinton Support', '#contact-brilinton-support']
        ],
        '/pages/warranty-repairs': [
          ['Warranty Coverage', '#warranty-coverage'],
          ['Warranty Claims', '#warranty-claims'],
          ['Warranty Exclusions', '#warranty-exclusions'],
          ['Product Repairs', '#product-repairs']
        ]
      };
    }

    if (root.classList.contains('center-page--policies-legal')) {
      return {
        '/policies/privacy-policy': [
          ['Privacy Overview', '#privacy-overview'],
          ['Personal Information We Collect', '#personal-information-we-collect'],
          ['Sources Of Personal Information', '#sources-of-personal-information'],
          ['How We Use Personal Information', '#how-we-use-personal-information'],
          ['Cookies And Similar Technologies', '#cookies-and-similar-technologies'],
          ['How We Disclose Personal Information', '#how-we-disclose-personal-information'],
          ['Shopify Relationship', '#shopify-relationship'],
          ['Marketing And Privacy Choices', '#marketing-and-privacy-choices'],
          ['International Transfers', '#international-transfers'],
          ['Retention And Security', '#retention-and-security'],
          ['Children’s Privacy', '#children-s-privacy'],
          ['Your Rights And Choices', '#your-rights-and-choices'],
          ['Complaints, Updates, And Contact', '#complaints-updates-and-contact']
        ],
        '/policies/refund-policy': [
          ['Policy Overview', '#policy-overview'],
          ['Return Window', '#return-window'],
          ['Return Eligibility', '#return-eligibility'],
          ['Non-Returnable Items', '#non-returnable-items'],
          ['Defective Or Incorrect Items', '#defective-or-incorrect-items'],
          ['Return Authorization', '#return-authorization'],
          ['Refunds And Processing', '#refunds-and-processing'],
          ['Exchanges And Replacements', '#exchanges-and-replacements'],
          ['Cancellations And Pre-Orders', '#cancellations-and-pre-orders'],
          ['Failed Delivery And Uncollected Shipments', '#failed-delivery-and-uncollected-shipments'],
          ['International Returns And Customs', '#international-returns-and-customs'],
          ['Liability And Policy Updates', '#liability-and-policy-updates']
        ],
        '/policies/shipping-policy': [
          ['Policy Overview', '#policy-overview'],
          ['Fulfillment And Processing', '#fulfillment-and-processing'],
          ['Inventory, Pre-Orders, And Limited Products', '#inventory-pre-orders-and-limited-products'],
          ['Shipping Methods And Costs', '#shipping-methods-and-costs'],
          ['Fulfillment Locations And Routing', '#fulfillment-locations-and-routing'],
          ['Tracking And Delivery', '#tracking-and-delivery'],
          ['Address Accuracy And Delivery Access', '#address-accuracy-and-delivery-access'],
          ['Risk, Insurance, And Carrier Issues', '#risk-insurance-and-carrier-issues'],
          ['Duties, Taxes, And Customs', '#duties-taxes-and-customs'],
          ['Failed Delivery And Returned Shipments', '#failed-delivery-and-returned-shipments'],
          ['Order Delays And Legal Requirements', '#order-delays-and-legal-requirements'],
          ['Force Majeure And Policy Updates', '#force-majeure-and-policy-updates']
        ],
        '/policies/terms-of-service': [
          ['Introduction And Acceptance', '#introduction-and-acceptance'],
          ['Eligibility And Account Use', '#eligibility-and-account-use'],
          ['Orders And Acceptance', '#orders-and-acceptance'],
          ['Products And Availability', '#products-and-availability'],
          ['Pricing And Payment', '#pricing-and-payment'],
          ['Archive, Final Sale, And Limited Releases', '#archive-final-sale-and-limited-releases'],
          ['Shipping, Returns, And Cancellations', '#shipping-returns-and-cancellations'],
          ['Intellectual Property', '#intellectual-property'],
          ['User Content And Submissions', '#user-content-and-submissions'],
          ['Third-Party Services', '#third-party-services'],
          ['Prohibited Conduct', '#prohibited-conduct'],
          ['Warranty Disclaimer And Product Limitations', '#warranty-disclaimer-and-product-limitations'],
          ['Limitation Of Liability And Indemnity', '#limitation-of-liability-and-indemnity'],
          ['Governing Law And Disputes', '#governing-law-and-disputes'],
          ['Policy Changes And Contact', '#policy-changes-and-contact']
        ]
      };
    }

    return {};
  }

  function normalizeUrlPath(url) {
    try { return new URL(url, window.location.origin).pathname.replace(/\/+$/, '') || '/'; }
    catch (error) { return (url || '').split('#')[0].replace(/\/+$/, '') || '/'; }
  }

  CenterPage.prototype.buildStaticSidebarAccordions = function () {
    var map = getStaticSubmenuMap(this.root);
    if (!Object.keys(map).length) return;
    var currentPath = normalizeUrlPath(window.location.pathname);

    this.root.querySelectorAll('.center-sidebar__group').forEach(function (group) {
      var link = group.querySelector(':scope > .center-sidebar__category-link, :scope > .center-drawer__category-link');
      var button = group.querySelector(':scope > .center-sidebar__category, :scope > .center-drawer__category');
      var path = '';

      if (link) {
        path = normalizeUrlPath(link.getAttribute('href'));
        var replacement = document.createElement('button');
        replacement.type = 'button';
        replacement.className = link.className
          .replace('center-sidebar__category-link', 'center-sidebar__category')
          .replace('center-drawer__category-link', 'center-drawer__category');
        replacement.innerHTML = link.innerHTML;
        if (!replacement.querySelector('.center-caret')) {
          var caret = document.createElement('span');
          caret.className = 'center-caret';
          caret.setAttribute('aria-hidden', 'true');
          replacement.appendChild(caret);
        }
        replacement.setAttribute('aria-expanded', group.classList.contains('is-open') ? 'true' : 'false');
        link.replaceWith(replacement);
        button = replacement;
      } else if (button) {
        var firstGenerated = group.querySelector(':scope > .center-sidebar__section-list a[href], :scope > .center-drawer__section-list a[href]');
        path = firstGenerated ? normalizeUrlPath(firstGenerated.getAttribute('href')) : currentPath;
      }

      if (!path || !map[path]) return;
      if (group.querySelector(':scope > .center-sidebar__section-list:not([data-center-submenu])')) return;
      if (group.querySelector(':scope > .center-sidebar__section-list[data-center-submenu]')) return;

      var list = document.createElement('ul');
      list.className = 'center-sidebar__section-list';
      map[path].forEach(function (entry) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'center-sidebar__section-link';
        a.textContent = entry[0];
        a.href = path + entry[1];
        if (path === currentPath) {
          a.href = entry[1];
          a.classList.add('center-scroll-link');
        }
        li.appendChild(a);
        list.appendChild(li);
      });
      group.appendChild(list);
    });
  };

  CenterPage.prototype.init = function () {
    this.buildStaticSidebarAccordions();
    this.buildSectionMenus();
    this.bindSections();
    this.bindSidebarGroups();
    this.bindMobilePageSwitches();
    this.enhanceActionInfoBlocks();
    this.attachSupportBlock();
    this.openInitialHash();
    this.bindHashChange();
  };

  CenterPage.prototype.buildSectionMenus = function () {
    var self = this;
    document.querySelectorAll('[data-center-submenu]').forEach(function (menu) {
      var category = menu.getAttribute('data-center-category') || '';
      menu.innerHTML = '';

      self.panels.forEach(function (panel) {
        if (!panel.id) return;
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + panel.id;
        link.className = 'center-sidebar__section-link center-scroll-link';
        link.setAttribute('data-subheading', category);
        link.textContent = getTitle(panel);
        item.appendChild(link);
        menu.appendChild(item);
      });
    });

    this.scrollLinks = Array.from(document.querySelectorAll('.center-scroll-link'));
    this.bindScrollLinks();
  };

  CenterPage.prototype.findTarget = function (hash) {
    var cleanHash = normalizeHash(hash);
    if (!cleanHash || cleanHash === '#') return null;
    try {
      return this.contentArea.querySelector(cleanHash);
    } catch (error) {
      return document.getElementById(cleanHash.replace('#', ''));
    }
  };

  CenterPage.prototype.getSectionFromTarget = function (target) {
    if (!target) return null;
    if (target.classList && target.classList.contains('center-section')) return target;
    return target.closest('.center-section');
  };

  CenterPage.prototype.setOpenSection = function (section) {
    this.panels.forEach(function (panel) {
      var isOpen = section && panel === section;
      panel.classList.toggle('is-open', isOpen);
      var trigger = panel.querySelector('.center-section__summary');
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  };

  CenterPage.prototype.clearActiveLinks = function () {
    this.scrollLinks.forEach(function (link) { link.classList.remove('active', 'is-active'); });
    if (this.subTabHeading) this.subTabHeading.textContent = this.pageTitle || this.subTabHeading.dataset.defaultSubheading || '';
  };

  CenterPage.prototype.setActiveLink = function (sectionHash) {
    var activeLink = null;
    this.scrollLinks.forEach(function (link) {
      var isMatch = link.getAttribute('href') === sectionHash;
      link.classList.toggle('active', isMatch);
      link.classList.toggle('is-active', isMatch);
      if (isMatch && !activeLink) activeLink = link;
    });

    if (activeLink && this.subTabHeading) this.subTabHeading.textContent = activeLink.textContent.trim();

    document.querySelectorAll('.center-sidebar__group, .center-drawer__group').forEach(function (group) {
      if (group.querySelector('.center-scroll-link[href="' + sectionHash + '"]')) group.classList.add('is-open');
    });
  };

  CenterPage.prototype.closeDrawer = function () {
    if (!this.drawer) return;
    var restoreY = 0;
    if (document.body.style.position === 'fixed') {
      restoreY = Math.abs(parseInt(document.body.style.top || '0', 10)) || 0;
    }
    this.drawer.classList.remove('active', 'is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('center-drawer-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    if (restoreY) window.scrollTo(0, restoreY);
    document.querySelectorAll('[data-center-nav-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  };

  CenterPage.prototype.scrollToElement = function (element, smooth) {
    if (!element) return;
    var stickyNav = document.querySelector('.sticky-nav--center.sticky-nav--is-fixed, .sticky-nav--center.is-fixed, .sticky-nav--center.is-stuck');
    var headerBottom = 0;
    var headers = Array.from(document.querySelectorAll('.shopify-section-header-sticky, .section-header, sticky-header, .shopify-section-group-header-group'));
    headers.forEach(function (header) {
      var rect = header.getBoundingClientRect();
      if (rect.bottom > headerBottom && rect.top < window.innerHeight) headerBottom = rect.bottom;
    });
    var offset = Math.round(headerBottom) + (stickyNav ? stickyNav.offsetHeight : 44) + 14;
    var y = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
  };

  CenterPage.prototype.openSection = function (hash, options) {
    var opts = options || {};
    var cleanHash = normalizeHash(hash);
    var target = this.findTarget(cleanHash);
    var section = this.getSectionFromTarget(target);
    if (!section || !section.id) return;

    var sectionHash = '#' + section.id;
    this.setOpenSection(section);
    this.setActiveLink(sectionHash);
    this.closeDrawer();

    if (opts.updateHash !== false || cleanHash !== hash) history.replaceState(null, '', cleanHash);
    if (opts.scroll) {
      var self = this;
      window.requestAnimationFrame(function () {
        self.scrollToElement(target || section, opts.smooth);
      });
    }
  };

  CenterPage.prototype.closeAllSections = function () {
    this.setOpenSection(null);
    this.clearActiveLinks();
    history.replaceState(null, '', window.location.pathname + window.location.search);
  };

  CenterPage.prototype.bindSections = function () {
    var self = this;
    this.panels.forEach(function (panel) {
      var trigger = panel.querySelector('.center-section__summary');
      if (!trigger || !panel.id) return;
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-expanded', panel.classList.contains('is-open') ? 'true' : 'false');

      var toggle = function () {
        if (panel.classList.contains('is-open')) return;
        self.openSection('#' + panel.id, { updateHash: true, scroll: true, smooth: true });
      };

      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  };

  CenterPage.prototype.bindScrollLinks = function () {
    var self = this;
    this.scrollLinks.forEach(function (link) {
      if (link.dataset.centerLinkBound === 'true') return;
      link.dataset.centerLinkBound = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        self.openSection(link.getAttribute('href'), { updateHash: true, scroll: true, smooth: true });
      });
    });
  };

CenterPage.prototype.bindSidebarGroups = function () {
  document.querySelectorAll('.center-sidebar__category, .center-drawer__category').forEach(function (button) {
    if (button.tagName === 'A' || button.dataset.centerGroupBound === 'true') return;

    button.dataset.centerGroupBound = 'true';

    button.addEventListener('click', function () {
      var group = button.closest('.center-sidebar__group, .center-drawer__group');
      if (!group) return;

      var nextOpen = !group.classList.contains('is-open');
      var parent = group.parentElement;

      if (parent) {
        parent.querySelectorAll(':scope > .center-sidebar__group.is-open, :scope > .center-drawer__group.is-open').forEach(function (sibling) {
          if (sibling === group) return;

          sibling.classList.remove('is-open');

          var siblingButton = sibling.querySelector(':scope > .center-sidebar__category, :scope > .center-drawer__category');
          if (siblingButton) siblingButton.setAttribute('aria-expanded', 'false');
        });
      }

      group.classList.toggle('is-open', nextOpen);
      button.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
    });
  });
};

  CenterPage.prototype.bindMobilePageSwitches = function () {
    document.querySelectorAll('[data-center-mobile-switch]').forEach(function (select) {
      if (select.dataset.centerSwitchBound === 'true') return;
      select.dataset.centerSwitchBound = 'true';
      select.addEventListener('change', function () {
        if (select.value) window.location.href = select.value;
      });
    });
  };

  CenterPage.prototype.enhanceActionInfoBlocks = function () {
    var blocks = Array.from(this.root.querySelectorAll('.center-sidebar--action .center-contact-info__block'));
    blocks.forEach(function (block, index) {
      if (block.dataset.centerInfoAccordion === 'true') return;
      var title = block.querySelector('h3');
      if (!title) return;

      var titleText = title.textContent.trim();
      var body = document.createElement('div');
      body.className = 'center-info-accordion__body';
      body.id = 'center-info-accordion-' + Math.random().toString(36).slice(2);

      var node = title.nextSibling;
      while (node) {
        var next = node.nextSibling;
        body.appendChild(node);
        node = next;
      }

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'center-info-accordion__summary';
      button.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
      button.setAttribute('aria-controls', body.id);
      button.innerHTML = '<span>' + titleText + '</span><span class="center-info-accordion__caret" aria-hidden="true"></span>';

      title.remove();
      block.classList.add('center-info-accordion');
      if (index === 0) block.classList.add('is-open');
      block.dataset.centerInfoAccordion = 'true';
      block.appendChild(button);
      block.appendChild(body);

      button.addEventListener('click', function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        var isOpen = block.classList.contains('is-open');
        blocks.forEach(function (other) {
          other.classList.remove('is-open');
          var otherButton = other.querySelector('.center-info-accordion__summary');
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          block.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  };

  CenterPage.prototype.attachSupportBlock = function () {
    var contentWrap = this.root.querySelector('.center-article__inner');
    var template = document.getElementById('center-page-support-template');
    if (!contentWrap || !template || contentWrap.querySelector('.center-support')) return;

    var support = template.querySelector('.center-support');
    if (!support) return;

    var clone = support.cloneNode(true);
    clone.classList.add('center-support--auto');
    contentWrap.appendChild(clone);
  };

  CenterPage.prototype.openInitialHash = function () {
    var self = this;
    if (window.location.hash && this.findTarget(window.location.hash)) {
      setTimeout(function () { self.openSection(window.location.hash, { updateHash: false, scroll: true, smooth: false }); }, 0);
    } else if (this.panels[0] && this.panels[0].id) {
      this.openSection('#' + this.panels[0].id, { updateHash: false, scroll: false });
    } else {
      this.setOpenSection(null);
      this.clearActiveLinks();
    }
  };

  CenterPage.prototype.bindHashChange = function () {
    var self = this;
    window.addEventListener('hashchange', function () {
      if (window.location.hash && self.findTarget(window.location.hash)) {
        self.openSection(window.location.hash, { updateHash: false, scroll: true, smooth: true });
      } else if (self.panels[0] && self.panels[0].id) {
        self.openSection('#' + self.panels[0].id, { updateHash: false, scroll: false });
      } else {
        self.setOpenSection(null);
        self.clearActiveLinks();
      }
    });
  };

  function init(root) {
    (root || document).querySelectorAll('[data-center-page]').forEach(function (el) {
      if (el.dataset.centerPageBound === 'true') return;
      el.dataset.centerPageBound = 'true';
      new CenterPage(el);
    });
  }

  window.BrilintonCenterPageController = { init: init };

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
